export type { DetailInfoListProps } from "./detail-info-list";
export { DetailInfoList } from "./detail-info-list";
